import { render, staticRenderFns } from "./scanProofread.vue?vue&type=template&id=6b148a9a"
import script from "./scanProofread.vue?vue&type=script&lang=js"
export * from "./scanProofread.vue?vue&type=script&lang=js"
import style0 from "./scanProofread.vue?vue&type=style&index=0&id=6b148a9a&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports